module.exports = __webpack_public_path__ + "img/stand_linche.69bf245b.jpg";